import router from "src/routes/routes";
import { createCrudService } from "./crudFactory";
import CommonAPIService from "./commonHandler";

const api = new CommonAPIService(router);

const baseService = createCrudService("cst", [], router);

export const cstService = {
  ...baseService,

  getByClient: async (clientId) => {
    return api.getCall(`/api/cst/client/${clientId}`);
  },

  getAllByClient: async (clientId) => {
    return api.getCall(`/api/cst/client/${clientId}/all`);
  },

  getFull: async (id) => {
    return api.getCall(`/api/cst/${id}/full`);
  },

  generateFromIntake: async (intakeFormId) => {
    return api.postCall(`/api/cst/generate-from-intake`, { intakeFormId });
  },

  uploadPdf: async (formData) => {
    return api.postFormDataCall(`/api/cst/upload-pdf`, formData);
  },

  publish: async (id) => {
    return api.postCall(`/api/cst/${id}/publish`);
  },

  acknowledge: async (id, signatureImage) => {
    return api.postCall(`/api/cst/${id}/acknowledge`, { signature_image: signatureImage });
  },

  getAcknowledgments: async (id) => {
    return api.getCall(`/api/cst/${id}/acknowledgments`);
  },

  getPendingForCaregiver: async (caregiverId) => {
    return api.getCall(`/api/cst/caregiver/${caregiverId}/pending`);
  },

  linkPrograms: async (id, programIds) => {
    return api.postCall(`/api/cst/${id}/programs`, { programIds });
  },
};
